import React from "react"
import { Link, withRouter } from "react-router-dom"
import { withStyles, Paper } from "@material-ui/core"
import logradouroStyle from "../../../assets/css/layout/logradouroStyle"
import Button from "../../../components/CustomButtons/Button"
import TablePagination from "@material-ui/core/TablePagination";
import Print from "@material-ui/icons/Print"
import Delete from "@material-ui/icons/Delete"
import Dialog from "@material-ui/core/Dialog";
import Typography from "@material-ui/core/Typography";
import DialogContent from "@material-ui/core/DialogContent";
import Card from "../../../components/Card/Card"
import Lens from "@material-ui/icons/Lens"
import CardHeader from "../../../components/Card/CardHeader"
import AdBlockDetect from "react-ad-block-detect";
import CardBody from "../../../components/Card/CardBody"
import AddIcon from "@material-ui/icons/Add"
import Grid from "@material-ui/core/Grid"
import Table from "../../../components/Table/Table"
import { get, search, imprimirPagamento, removePag, imprimirPagTermo } from "../../../util/pagamentoDeDivida"
import Search from "../../../components/Search";
import { showNotification, showWaiting, hideWaiting } from "../../../util/Constants"
import LoadingContent from "../../../components/LoadingContent"
import housecall from "housecall"
import DialogActions from "@material-ui/core/DialogActions"
import DialogTitle from "@material-ui/core/DialogTitle"
// import ChromeReaderMode from "@material-ui/icons/ChromeReaderMode"
class Pagamento extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      value: "",
      error: "",
      errors: {},
      nome: "",
      pagamentos: [],
      pageCount: 0,
      perPage: 0,
      page: 0,
      isSearch:false,
      field: 0,
      modal: false,
      id: 0,
      searchText: "",
      modalRemover: false
    }
    this.getData = this.getData.bind(this)
    this.filter = this.filter.bind(this)
    this.handlePageClick = this.handlePageClick.bind(this)
    this.handleChangePage = this.handleChangePage.bind(this)
    this.handleEdit = this.handleEdit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.queue = housecall({ concurrency: 1, cooldown: 0 })
    this.toggleLoading = this.toggleLoading.bind(this)
    this.handleChangeFilters = this.handleChangeFilters.bind(this)
    this.setLoadingFalse = this.setLoadingFalse.bind(this)
    this.imprimirCarneRef = this.imprimirCarneRef.bind(this)
    this.openRemover = this.openRemover.bind(this)
    this.closeRemover = this.closeRemover.bind(this)
    this.remover = this.remover.bind(this)
    this.imprimirTermo = this.imprimirTermo.bind(this)
  }

  imprimirTermo(key) {
    showWaiting()
    let response = (error, data) => {
      if (error) {
        hideWaiting()
        const reader = new FileReader()
        reader.addEventListener("loadend", e => {
          const text = e.srcElement.result
          try {
            let error = JSON.parse(text)
            let status = error.status
            if (status === "pago") {
              showNotification(
                "top",
                "center",
                `Ocorreram erros! ${error.message}!`,
                "danger"
              )
            }
          } catch (e) {
            showNotification(
              "top",
              "center",
              `Ocorreram erros! ${error.message}`,
              "danger"
            )
          }
        })
        reader.readAsText(error.response.data)
      } else {
        hideWaiting()
        var url = URL.createObjectURL(data)
        let tempLink = document.createElement("a")
        tempLink.setAttribute("target", "_blank")
        tempLink.setAttribute("href", `${url}`)
        tempLink.setAttribute("style", "display:none;")
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
      }
    }
    imprimirPagTermo(this.state.pagamentos[key].id, response)
  }

  openRemover(key) {
    this.setState({
      modalRemover: true,
      id: this.state.pagamentos[key].id
    })
  }

  closeRemover() {
    this.setState({
      modalRemover: false
    })
  }

  remover() {
    showWaiting()
    let response = (error, data) => {
      hideWaiting()
      if (error) {
        showNotification(
          "top",
          "center",
          "Ocorreram erros! Tente novamente",
          "danger"
        )
      } else {
        showNotification(
          "top",
          "center",
          "Pagamento removido com sucesso!",
          "success"
        )
        this.closeRemover()
        this.getData()
      }
    }
    removePag(this.state.id, response)
  }

  imprimirCarneRef(key) {
    showWaiting();
    let response = (error, data) => {
      if (error) {
        hideWaiting()
        const reader = new FileReader()
        reader.addEventListener("loadend", e => {
          const text = e.srcElement.result
          try {
            let error = JSON.parse(text)

            let status = error.status
            if (status === "pago") {
              showNotification(
                "top",
                "center",
                `Ocorreram erros! ${error.message}!`,
                "danger"
              )
            }
          } catch (e) {
            showNotification(
              "top",
              "center",
              `Ocorreram erros! ${error.message}`,
              "danger"
            )
          }
        })

        reader.readAsText(error.response.data)
      } else {
        hideWaiting();
        var url = URL.createObjectURL(data);
        let tempLink = document.createElement("a");
        tempLink.setAttribute("target", "_blank");
        tempLink.setAttribute("href", `${url}`);
        tempLink.setAttribute("style", "display:none;");
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
      }
    };
    imprimirPagamento(this.state.pagamentos[key].id, response);
  }

  handleChangeFilters = event => {
    this.setState({ filterField: event.target.value }, () => {
      if (this.state.searchActive) {
        this.filter({ target: { value: this.state.searchText } })
      }
    })
  }

  filter(event,pagina) {
    let searchText = event.target.value
    var newState = {
      searchText: searchText,
      searchActive: searchText !== "",
      isLoading:true,
   
    }
    if(pagina == null){
      newState['page'] = 0
    }
    this.setState(
        newState
      ,
      () => {
        if (this.state.searchActive) {

          let filtersCheckbox = this.state.filterField || ""
          // this.queue.push(() =>
          search(searchText, filtersCheckbox, undefined, (error, data) => {
            this.setState({
              isLoading:false
        
            })
            if (error) {
              showNotification(
                "top",
                "center",
                "Ocorreram erros, verifique sua conexão com a internet",
                "danger"
              )
            } else {
              this.setState({
                pagamentos: data.data,
                pageCount: data.total,
                perPage: data.per_page,

              })

            }
          },pagina)
          // )
        } else {
          this.getData()
        }
      }
    )
  }

  componentWillMount() {
    this.getData()
  }
  setLoadingFalse() {
    this.setState({
      isLoading: false
    })
  }
  componentDidMount() {
    this.queue.on("idle", this.setLoadingFalse)
  }
  handlePageClick(data) {
    //this.getData(data.selected + 1);
  }


  handleChangePage = (event, page) => {
    var pagina;
    pagina = page + 1;
    this.setState({page: page})
    if(page < 0){
      return;
    }
    if (this.state.searchText.toString().trim() != "") {
      this.filter({target: {value: this.state.searchText}}, pagina, page)
      return;
    }
    this.getData(pagina)
  };

  handleChange(event) {

    let name = event.target.name
    let errors = this.state.errors
    errors[name] = undefined
    this.setState({
      [name]: event.target.value,
      errors: errors
    })
  }
  toggleLoading() {
    this.setState(state => ({
      isLoading: !state.isLoading
    }))
  }
  getData(page) {
    this.setState({isLoading:true})

    get(page, (error, data) => {
      this.setState({   
        isLoading:false})

      if (error) {
        showNotification(
          "top",
          "center",
          "Ocorreram erros, verifique o formulário e tente novamente",
          "danger"
        )
      } else {
        this.setState({
          pagamentos: data.data,
          pageCount: data.total,
          perPage: data.per_page,

        })
      }
    })
  }

  handleEdit(key) {
    this.props.history.push(
      "/divida/pagamento/edit/" + this.state.pagamentos[key].id
    )
  }

  render() {
    const { classes } = this.props

    const fields = [
      { value: "", label: "Todos os campos" },
      { value: "id", label: "Código de baixa" },
      { value: "contribuinte_id", label: "Código do Contribuinte" },
      { value: "contribuinte_nome_razao_social", label: "Razão Social" },
    ];
    return (
      <div className={classes.container}>
        <Card>
          <CardHeader color="primary">
            <Grid container direction="row" spacing={8}>
              <Grid item lg={10} xs={12}>
                <h2 className={classes.cardTitleWhite}>Pagamento de dívida (Parcelamento)</h2>
              </Grid>
              <Grid item lg={2} xs={12}>
                <Link
                  to="/divida/pagamento/create"
                  style={{ textDecoration: "none" }}
                >
                  <Button block color="success" round>
                    <AddIcon /> Novo
                  </Button>
                </Link>
              </Grid>
            </Grid>
          </CardHeader>
          <CardBody>
            <Search
              label="Pesquise aqui"
              value={this.state.filterField}
              onChangeText={this.filter}
              onChangeFields={this.handleChangeFilters}
              fields={fields}
            />
            <Grid className={classes.legend} container direction="row">
              <Lens className={classes.dot + " " + classes.dotSuccess} />
              Parcelamento pago
            </Grid>
            <LoadingContent isLoading={this.state.isLoading}>
              <Paper className={classes.tableWrapper}>
                <Table
                  getRowColor={(key, classes) => {
                    if (this.state.pagamentos[key].pago) {
                      return classes.successTableRow
                    } else if (this.state.pagamentos[key].pago) {
                      return classes.dangerTableRow
                    } else {
                      return ""
                    }
                  }
                  }
                  tableHeaderColor="primary"
                  actions={[
                    {
                      title: "Imprimir Carnê",
                      icon: (
                        <Print
                          className={
                            classes.tableAsctionButtonIcon +
                            " " +
                            classes.imprimir
                          }
                        />
                      ),
                      onClick: key => this.imprimirCarneRef(key)
                    },
                    // {
                    //   title: "Imprimir Termo",
                    //   icon: (
                    //     <ChromeReaderMode
                    //       className={
                    //         classes.tableActionButtonIcon +
                    //         " " +
                    //         classes.description
                    //       }
                    //     />
                    //   ),
                    //   onClick: key => this.imprimirTermo(key)
                    // },
                    {
                      title: "Remover",
                      icon: (
                        <Delete
                          className={
                            classes.tableActionButtonIcon +
                            " " +
                            classes.close
                          }
                        />
                      ),
                      onClick: key => this.openRemover(key)
                    }

                  ]}
                  tableHead={["Código", "Contribuinte", "Quantidade de parcelas"]}
                  tableData={this.state.pagamentos.map((item, key) => {
                    return [item.id + "", item.contribuinte.nome_razao_social, item.parcelas.length + "", key]
                  })}
                />
                {(
                  <TablePagination
                    component="div"
                    rowsPerPageOptions={[]}
                    count={this.state.pageCount}
                    rowsPerPage={this.state.perPage?this.state.perPage:0}
                    page={this.state.page?this.state.page:0}
                    backIconButtonProps={
                    
                          {"aria-label": "Previous Page"}}
                    nextIconButtonProps={ {
                      "aria-label": "Next Page",
                    }}

                    SelectProps={{
                      native: true
                    }}

                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                  />
                )}
              </Paper>
            </LoadingContent>
          </CardBody>
        </Card>

        {/* adblock */}
        <AdBlockDetect>
          <Dialog open={true} aria-labelledby="form-dialog-title">
            <form onSubmit={this.handleSave}>
              <DialogContent>
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  direction="row"
                >
                  <Grid item xs={12} sm={12} md={8} lg={8}>
                    <Typography variant="h5" gutterBottom>
                      Por favor, desabilite o ADBlock para impressão de carnês.
                    </Typography>
                  </Grid>
                </Grid>
              </DialogContent>
            </form>
          </Dialog>
        </AdBlockDetect>

        {/* dialog confirmacao */}
        <Dialog
          open={this.state.modalRemover}
          onClose={this.closeRemover}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Você tem certeza que deseja remover esse pagamento?</DialogTitle>

          <DialogActions>
            <Button onClick={this.closeRemover} color="danger">
              Cancelar
              </Button>
            <Button onClick={this.remover} color="success">
              Confirmar
              </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}
Pagamento = withRouter(Pagamento)
export default withStyles(logradouroStyle)(Pagamento)